import { Provider } from 'store/api/enums';

export function getProviderName(provider: string | undefined | null) {
  if (!provider) return '';
  const providerLower = provider.toLowerCase();
  
  if (providerLower === Provider.XERO) return 'Xero';
  if (providerLower === Provider.CIN7) return 'Cin7';
  if (providerLower === Provider.QUICKBOOKS) return 'QuickBooks';
  if (providerLower === Provider.ZOHO) return 'Zoho Books';
  if (providerLower === Provider.EXCEL) return 'Excel / CSV';
  if (providerLower === Provider.RECEIPTS) return 'AI Scan Receipts & Bills';

  return toTitleCase(provider);
}

function toTitleCase(str: string) {
  if (!str) return '';
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}
